import _get from "lodash/get";
import { IMAGE_SIZES, MONETIZATION_STATUSES } from '../constants';
import { getIsMonetizing, getMonetizable } from '../selectors/common';
/**
 * Get name of current entity or ancestor entities.
 *
 * @private
 *
 * @todo This function should likely be avoided going forward. It is
 *     overly generic and doesn't accurately represent the name logic
 *     associated with each product type. Instead, we should clarify
 *     what specific name is used for specific selectors (offer vs
 *     product vs institution, .display_name vs. .name, etc).
 *
 * @param {Object} marketplaceEntity The marketplace entity.
 *
 * @return {string} Name.
 */

export var getNameWithFallbacks = function getNameWithFallbacks(marketplaceEntity) {
  return _get(marketplaceEntity, 'name') || _get(marketplaceEntity, 'product.name') || _get(marketplaceEntity, 'product.institution.name');
};
/**
 * Get an entity's image URL by specific size, with fallbacks.
 *
 * @param {Object} marketplaceEntity The marketplace entity.
 * @param {string} size Canonical image size to select.
 *
 * @return {string} Image URL.
 */

export var getImageBySize = function getImageBySize(marketplaceEntity, size) {
  return size && _get(marketplaceEntity, "details.image_source_".concat(size, ".value")) || _get(marketplaceEntity, "details.image_source_".concat(IMAGE_SIZES.LARGE, ".value")) || _get(marketplaceEntity, "details.image_source_".concat(IMAGE_SIZES.MEDIUM, ".value")) || _get(marketplaceEntity, 'details.image_source.value');
};
/**
 * Get a WordPress augmented marketplaceEntity's additional data object.
 *
 * @param   {Object} marketplaceEntity  The `additional_data` augmented entity
 * @return  {Object}                    additional_data entity
 */

export var getAdditionalData = function getAdditionalData(marketplaceEntity) {
  return _get(marketplaceEntity, 'additional_data');
};
/**
 * Returns true if a marketplaceEntity is non-monetizing.
 * If monetizable field exists, considers non-monetizing if the field is not yes_assumed.
 * Otherwise, consider an entity as non-monetizing only if the value is explicitly defined as false.
 * This ensures that we proceed with default behavior if the field is not defined in the entity.
 *
 * @param  {Object}  marketplaceEntity The marketplace entity
 *
 * @return {boolean}                   If the entity is non-monetizing
 */

export var isNonMonetizing = function isNonMonetizing(marketplaceEntity) {
  var monetizable = getMonetizable(marketplaceEntity);

  if (monetizable) {
    return monetizable !== MONETIZATION_STATUSES.YES_ASSUMED;
  }

  return getIsMonetizing(marketplaceEntity) === false;
};